













































import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';
import { inject } from "inversify-props";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { EventStatModel } from "@/models/stat";
import { IStatService, EventStatFilter, ConstantDescriber, ConstantValue } from "@/interfaces/Services";
import { RealFactorActivity } from '../models/patient';

@Component({components: {}})
export class EventStatTableCard extends Vue {
  @inject(DependencyIdentifiers.StatService)
  private statService!: IStatService;

  @Prop({required: true})
  private filter!: EventStatFilter;

  @Prop({required: false, default: false})
  private flat?: boolean;

  private isLoading = false;
  private consts!: ConstantDescriber;
  private componentKey = 0;
  private items: Array<EventStatModel> = [];
  private total = 0;

  private get headers() {
    return [
      {
        text: this.$t('stat.event.fields.age'),
        align: "left",
        value: "age"
      },
      {
        text: this.$t('stat.event.fields.methodOfTreatment'),
        align: "left",
        value: "methodOfTreatment"
      },
      {
        text: this.$t('stat.event.fields.inhibitor'),
        align: "left",
        value: "inhibitor"
      },
      {
        text: this.$t('stat.event.fields.bloodType'),
        align: "left",
        value: "bloodType"
      },
      {
        text: this.$t('stat.event.fields.factorActivities'),
        align: "left",
        value: "factorActivities"
      },
      {
        text: this.$t('stat.event.fields.hasWapps'),
        align: "left",
        value: "has_wapps"
      },
      {
        text: this.$t('stat.event.fields.eventType'),
        align: "left",
        value: "eventType"
      },
    ];
  }

  private options = {
    page: 1,
    itemsPerPage: 10,
    groupBy: [],
    groupDesc: [],
  };

  isFlat() {
    return this.flat;
  }

  async mounted() {
    this.consts = (this as any).apiConstants;
    await this.load();
  }

  private async load() {
    this.isLoading = true;
    try {
      const { page, itemsPerPage } = this.options;

      const [items, total] = await this.statService.getManyEvent(
        page,
        itemsPerPage,
        this.filter
      );

      this.total = total;
      this.items = [...items];
    } finally {
      this.isLoading = false;
    }
  }

  resolveMethodOfTreatment(value: string) {
    return this.resolveConst(this.consts.patient.treatment_method, value);
  }

  resolveFactorActivities(item: EventStatModel) {
    const factors: string[] = [];
    if (item.factorActivityLevelValueWillebrand) {
      factors.push('willebrand');
    }
    if (item.factorActivityLevelValueV) {
      factors.push('v');
    }
    if (item.factorActivityLevelValueVII) {
      factors.push('vii');
    }
    if (item.factorActivityLevelValueVIII) {
      factors.push('viii');
    }
    if (item.factorActivityLevelValueIX) {
      factors.push('ix');
    }
    if (item.factorActivityLevelValueX) {
      factors.push('x');
    }
    if (item.factorActivityLevelValueXIII) {
      factors.push('xiii');
    }
    return factors
      .map((factor) => this.resolveConst(this.consts.patient.factor_activity, factor))
      .join(', ');
  }

  resolveEventType(value: string) {
    return this.resolveConst(this.consts.event.type, value);
  }

  resolveBloodType(value: string) {
    return this.resolveConst(this.consts.patient.blood_type, value);
  }

  resolveConst(items: ConstantValue[], value: string): string {
    const result = items.find(e => e.value === value)
    return result ? result.label : value;
  }

  private async reset() {
    this.options.page = 1;
    await this.load();
  }

  @Watch("options", { deep: true })
  async onOptionsChange(val: any, oldVal: any) {
    await this.load();
    this.$emit('options-changed', this.options);
  }

  @Watch("filter", {deep: true})
  onFilterUpdate() {
    this.reset();
  }
}

export default EventStatTableCard;
